<ng-template #formContent>
	@if (loginConfig$ | async; as loginConfig) {
		<div class="login-form-container">
			@if (isFullscreen) {
				<img
					src="/studio/assets/logo.svg"
					alt="Lowgile"
					width="160"
					class="login-form-logo"
				/>
				<h1 class="login-title">Welcome back</h1>
				<p class="login-subtitle">Sign in to continue to your workspace</p>
			}

			@for (
				loginMethod of loginConfig.loginMethods;
				track loginMethod;
				let isLast = $last
			) {
				@switch (loginMethod) {
					@case ('credentials') {
						<mat-form-field appearance="outline" class="login-field">
							<mat-label>Username or E-Mail</mat-label>
							<input
								matInput
								type="text"
								name="username"
								[(ngModel)]="loginRequest.userName"
								#userNameInput
							/>
						</mat-form-field>

						@if (!recoveryToken) {
							<mat-form-field appearance="outline" class="login-field">
								<mat-label>Password</mat-label>
								<input
									matInput
									type="password"
									name="password"
									[(ngModel)]="loginRequest.password"
									#passwordInput
								/>
							</mat-form-field>
						}

						@if (
							recoveryToken || loginRequest.stage == 'passwordChangeNeeded'
						) {
							@if (!recoveryToken) {
								<p class="login-info-text">
									Your password has expired, please set a new password
								</p>
							}
							<mat-form-field appearance="outline" class="login-field">
								<mat-label>New password</mat-label>
								<input
									matInput
									type="password"
									name="newPassword"
									[(ngModel)]="loginRequest.newPassword"
									#passwordInput
								/>
							</mat-form-field>
							<mat-form-field appearance="outline" class="login-field">
								<mat-label>Repeat new password</mat-label>
								<input
									matInput
									type="password"
									name="newPassword2"
									[(ngModel)]="password2"
								/>
							</mat-form-field>
						}

						@if (loginResponse.nextStage == 'mfa') {
							<mat-form-field appearance="outline" class="login-field">
								<mat-label>Login PIN</mat-label>
								<input
									matInput
									#mfaTokenInput
									[(ngModel)]="loginRequest.mfaToken"
								/>
								<mat-hint>{{ getMfaTokenHint() }}</mat-hint>
								@if (
									loginResponse.nextStage == 'mfa' && loginResponse.hasPhone
								) {
									<button
										mat-stroked-button
										matSuffix
										(click)="requestToken()"
									>
										Request PIN
									</button>
								}
							</mat-form-field>
						}

						@if (!recoveryToken) {
							<button
								mat-flat-button
								color="primary"
								class="login-submit-btn"
								(click)="login()"
							>
								Sign in
							</button>
						}

						@if (recoveryToken) {
							<button
								mat-flat-button
								color="warn"
								class="login-submit-btn"
								(click)="setNewPassword()"
							>
								Set new password
							</button>
						}

						@if (loginRequest.stage == 'credentials' && !recoveryToken) {
							<div class="login-forgot">
								<a (click)="startPasswordRecovery()">
									Forgot your password?
								</a>
							</div>
						}
					}

					@case ('sso') {
						<button mat-stroked-button class="login-sso-btn" (click)="sso()">
							Login with SSO
						</button>
					}
				}

				@if (!isLast) {
					<div class="loginmethod-divider">
						<hr />
						<span>or</span>
						<hr />
					</div>
				}
			}
		</div>
	}
</ng-template>

@if (isFullscreen) {
	<div class="login-wrapper" (mousedown)="(false)">
		<div class="login-form-panel">
			<ng-container *ngTemplateOutlet="formContent"></ng-container>
		</div>
	</div>
} @else {
	<ng-container *ngTemplateOutlet="formContent"></ng-container>
}
